import { Observable } from '~/Utils/observable';
import { ICameraGeometryPoint } from '~/Scene/System/systemCamera';
import { _system } from '~/Services/Studio/studioScene';

export enum CanvasEvent {
    Screenshot,
    ShowScreenshot,
    HideScreenshot,
    ShowFrame,
    HideFrame,
    VideoFrame
}

export type ICanvasMode = 'screenshot' | 'frame';

class CanvasObservable extends Observable<CanvasEvent, ICameraGeometryPoint | ICanvasMode> {
    constructor() {
        super('CanvasScreenshot');
    }

    screenshot() {
        const geo = _system.getCurrentCameraGeometry();
        this.notify(CanvasEvent.Screenshot, geo);
    }
}

export const canvasObservable = new CanvasObservable();
